import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Api } from '../Model/api-model';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {AppListResponse} from '../Model/apilistresponse-model';
import {createapp,createappResponse} from '../Model/createappRequest-model';
import { ProductList } from '../Model/productList-model';
import { ApiListDevPortal } from '../Model/apilist-model';
import { MySubRequest } from '../Model/product-model';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})

export class ApicTokenService {
  
  region;
  
  apiURL=environment.getTokenEndPointsPKCE();
tokenRevokeURL=  environment.getTokenEndRevoke();



  basicAuth;
  constructor(private http: HttpClient) { 


    this.region = environment.getEnvironment();
   
   // this.apiURL = environment.getSpringBootApiUrl();
    this.basicAuth=environment.getBasicAuth();
   // console.log("Region---"+this.region);
   // console.log("apiURL---"+this.apiURL);
    //console.log("basic auth---"+this.basicAuth);

  }

  /*========================================
    consuming RESTful API
  =========================================*/

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
      
    })
  }  


    // Http Options for revoke
    httpOptionsRevoke = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-ibm-client-id': environment.getAmClientId()
        
      })
    }  
  


    revokeToken_PostRequest(api): Observable<any> {
      // console.log(api);
      // console.log(this.httpOptions);
       return this.http.post<any>(this.tokenRevokeURL, api,this.httpOptionsRevoke)
       .pipe(
         retry(1),
         catchError(this.handleError)
       )
     }  
  




   // CreateApp Post()method
  getToken_PostRequest(api): Observable<any> {
   // console.log(api);
   // console.log(this.httpOptions);
    return this.http.post<any>(this.apiURL, api,this.httpOptions)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }  
  
  // Error handling 
  handleError(error) {
     let errorMessage = '';
     if(error.error instanceof ErrorEvent) {
       // Get client-side error
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
     }
    // window.alert(errorMessage);
     return throwError(errorMessage);
  }

}